import React from 'react';
import { Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';

type CopyrightFooterProps = {
  className?: string;
};

const useStyles = makeStyles((theme) => ({
  text: {
    fontFamily: theme.typography.body1.fontFamily,
    alignSelf: 'center',
    color: theme.palette.text.secondary,
    padding: theme.spacing(4, 0)
  }
}));

export const CopyrightFooter: React.FC<CopyrightFooterProps> = ({
  className
}: CopyrightFooterProps) => {
  const copyrightYear = DateTime.local().year;
  const classes = useStyles();
  return (
    <Typography
      className={classnames(classes.text, className)}
      color="textSecondary"
      data-testid="copyright-message"
    >
      <FormattedMessage id="aboutDialog.copyright" values={{ copyrightYear }} />
    </Typography>
  );
};
